import React, { Component } from 'react';
import './style.css';
import { HeaderQuestion } from '../../components';
import ImageOrText from './imageortext';
import { Trans, translate } from 'react-i18next';
import { withRouter } from 'react-router-dom';

class Comparison extends Component {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.skip = this.skip.bind(this);
  }

  handleChange(event) {
    this.setState({ value: event.target.value });
  }

  handleSubmit(event) {
    event.preventDefault();
  }

  skip() {
    const nextPath = this.props.skip(this.props);
    if (this.props.history.canGo(1)) {
      this.props.history.goForward();
    } else {
      this.props.history.push(nextPath);
    }
  }

  render() {
    const { t } = this.props;
    var buttonClass = 'btn btn-light btn-round btn-block';
    if (this.props.colorButton) {
      buttonClass = 'btn btn-primary btn-round btn-block btn-danger';
    }
    const description = (
      <Trans i18nKey="preferenceDescription">Which one do you like better?</Trans>
    );

    return (
      <div className="card-body">
        <form onSubmit={this.handleSubmit}>
          <HeaderQuestion
            description={description}
            text={t('Just follow your intuition.')}
            pairId={this.props.pair.pairId}
          />
          <div className="App-comparison-text-center">
            <ImageOrText
              image={this.props.pair.projectObjects[0].image}
              name={this.props.pair.projectObjects[0].name}
              to={this.props.url + '/' + this.props.pair.projectObjects[0].uuid}
            />
            <ImageOrText
              image={this.props.pair.projectObjects[1].image}
              name={this.props.pair.projectObjects[1].name}
              to={this.props.url + '/' + this.props.pair.projectObjects[1].uuid}
            />
          </div>
          <button type="button" className={buttonClass} onClick={this.skip}>
            {t('Skip')}
          </button>
        </form>
      </div>
    );
  }
}

export default withRouter(translate('translations')(Comparison));



// WEBPACK FOOTER //
// ./src/preference/components/Pair/comparison.js